import { useEffect, useRef } from "react";
import {
  useVideoControlActions,
  useVideoControlState,
} from "components/scrapEyeDataDashboard/VideoPlayer/contexts/VideoControlContext";

export const usePauseVideoWhileOpen = (open: boolean) => {
  const { isPlaying } = useVideoControlState();
  const { pause, play } = useVideoControlActions();

  const wasPlayingRef = useRef(false);

  useEffect(() => {
    if (open) {
      wasPlayingRef.current = isPlaying;
      pause();
      return () => {
        if (wasPlayingRef.current) {
          play();
        }
      };
    }
    // eslint-disable-next-line @eslint-react/exhaustive-deps -- intentionally exclude isPlaying to capture state at modal open
  }, [open, pause, play]);
};
